import React, { useState, Fragment } from "react";
import { useParams, useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "@egovernments/digit-ui-react-components";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import ApplicationDetailsForm12 from "../../../../../templates/ApplicationDetails/form12";
import HouseIcon from '@mui/icons-material/House';
import { Loader } from "@egovernments/digit-ui-react-components";
import { Card } from "@mui/material";

const Form12Detail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEmployee = history.location.pathname.includes("employee");
  const [showToast, setShowToast] = useState(null);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [error, setError] = useState(null);
  const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee });
  const {
    applicationData,
    applicationDetails,
    businessService,
    edcrDetails,
    collectionBillDetails
  } = data;

  console.log("form12Details,", applicationData, applicationDetails, businessService, edcrDetails, collectionBillDetails, "ccccccc");
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate,
  } = Digit.Hooks.obps.useApplicationActions(stateId);

  const nocMutation = Digit.Hooks.obps.useObpsAPI(
    tenantId,
    true
  );
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: applicationData?.businessService,
  });

  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    workflowDetails.data.initialActionState = workflowDetails?.data?.initialActionState || { ...workflowDetails?.data?.actionState } || {};
    workflowDetails.data.actionState = { ...workflowDetails.data };
  }
  if (workflowDetails?.data?.processInstances?.length > 0) {
    let filteredActions = [];
    filteredActions = get(workflowDetails?.data?.processInstances[0], "nextActions", [])?.filter(
      item => item.action != "ADHOC"
    );
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || actions?.length == 0) && workflowDetails?.data?.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter(actn => actn.action !== "ADHOC");
  };
  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT")
  };


  if (isLoading || isEnableLoader) {
    return <Loader />;
  }


    return (
      <React.Fragment>
        {!isLoading && applicationData  ? (
        // {!isLoading && applicationData && (
          <React.Fragment>
             <Card style={{margin: "15px 0px 15px",padding: "8px" , position: "relative" }} className={"employeeCard-override"}>
           <HouseIcon style={{ color: 'red' }} /> Take Action</Card>
          <ApplicationDetailsForm12
            applicationDetails={applicationData}
            isLoading={isLoading}
            isDataLoading={updatingApplication}
            applicationData={applicationData}
            edcrDetails={edcrDetails}
            collectionBillDetails={collectionBillDetails}
            nocMutation={nocMutation}
            mutate={mutate}
            workflowDetails={workflowDetails}
            businessService={businessService}
            moduleCode={businessService}
            showToast={showToast}
            setShowToast={setShowToast}
            closeToast={closeToast}
            statusAttribute={"state"}
            timelineStatusPrefix={`WF_${workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : businessService}_`}
          />
           </React.Fragment>
        ) : (
          <Loader />
        )}
      </React.Fragment>
    );
  };

export default Form12Detail;